import React from "react";
import LineIcon from "./LineIcon";

const GuestDetailsForm = ({
  guestForm,
  onGuestChange,
  setBookingStep,
  bookingLoading,
}) => {
  return (
    <form
      className="be-page-booking-form"
      onSubmit={(e) => {
        e.preventDefault();
        setBookingStep("review");
      }}
    >
      <div className="be-form-row">
        <div className="be-form-group">
          <label htmlFor="booking-name">
            Full name *
          </label>

          <div className="be-input-with-icon">
            <LineIcon
              type="user"
              size={17}
            />

            <input
              id="booking-name"
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={guestForm.name}
              onChange={onGuestChange}
              required
            />
          </div>
        </div>

        <div className="be-form-group">
          <label htmlFor="booking-mobile">
            Mobile number *
          </label>

          <div className="be-input-with-icon">
            <LineIcon
              type="phone"
              size={17}
            />

            <input
              id="booking-mobile"
              type="tel"
              name="mobile"
              placeholder="+91 XXXXX XXXXX"
              value={guestForm.mobile}
              onChange={onGuestChange}
              required
            />
          </div>
        </div>
      </div>

      <div className="be-form-group">
        <label htmlFor="booking-email">
          Email address *
        </label>

        <div className="be-input-with-icon">
          <LineIcon
            type="mail"
            size={17}
          />

          <input
            id="booking-email"
            type="email"
            name="email"
            placeholder="you@example.com"
            value={guestForm.email}
            onChange={onGuestChange}
            required
          />
        </div>
      </div>

      <div className="be-form-group">
        <label htmlFor="booking-special-request">
          Special request
        </label>

        <textarea
          id="booking-special-request"
          name="specialRequest"
          rows="4"
          placeholder="Anything you would like us to know?"
          value={guestForm.specialRequest}
          onChange={onGuestChange}
        />
      </div>

      <button
        type="submit"
        className="be-page-submit-button"
        disabled={bookingLoading}
      >
        <span>
          {bookingLoading
            ? "Processing..."
            : "Request to book"}
        </span>

        {!bookingLoading && (
          <span className="be-submit-arrow">
            <LineIcon
              type="arrow"
              size={18}
            />
          </span>
        )}
      </button>

      <div className="be-booking-secure">
        <LineIcon
          type="shield"
          size={16}
        />

        <span>
          Your information is secure and
          will only be used for this
          reservation.
        </span>
      </div>
    </form>
  );
};

export default GuestDetailsForm;